<template>
  <div class="column-setting">
    <ul class="editor-design">
      <li>
        レイアウト
      </li>
      <li class="flex-box column-layout">
        <div class="edit-style-select-box">
          <span class="common-label">カラム数</span>
          <div class="common-select">
            <select
              :target="'column'"
              :value="partsCount"
              @input="updateNumberOfColumns($event.target.value)"
            >
              <option v-for="option in options" :key="option.value" :value="option.value">
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
        <div>
          <!-- モバイル表示 -->
          <li class="flex-box">
            <select-box
              :target="'flg-side'"
              :value="flgSide"
              @updateStyles="updatePartsContainer($event)"
            />
          </li>
        </div>
      </li>
      <!-- 間隔調整 -->
      <li class="flex-box" v-if="showSpacerWidth">
        <slider
          :prop="'spacer-width'"
          :value="spacerWidth"
          @updateStyles="updateSpacerSize($event)"
        />
      </li>
      <!-- 上下余白 -->
      <li class="flex-box">
        <slider
          :prop="'padding-top'"
          :value="partsContainerStyles['padding-top']"
          @updateStyles="updatePartsContainerStyles($event)"
        />
      </li>
      <!-- 左右余白 -->
      <li class="flex-box last">
        <slider
          :prop="'padding-right'"
          :value="partsContainerStyles['padding-right']"
          @updateStyles="updatePartsContainerStyles($event)"
        />
      </li>
    </ul>
    <!-- パーツの背景色 -->
    <edit-parts-container-style
      :styles="partsContainerStyles"
      :sectionId="sectionId"
      :partsContainerId="partsContainerId"
      :partsContainerType="partsContainerType"
    />
  </div>
</template>

<script>
import EditSettingSelectBase from '@/components/Content/Palette/CommonLayouts/Base/EditSettingSelectBase'
import EditPartsContainerStyle from '@/components/Content/Palette/EditPartDesign/Layouts/PartsContainerStyle'
import SelectBox from '@/components/Content/Palette/CommonLayouts/EditStyleSelectBox'
import Slider from '@/components/Content/Palette/CommonLayouts/EditStyleSlider'

export default {
  props: [
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'partsContainerStyles',
    'spacerParts',
    'columnCount',
    'flgSide',
  ],
  mixins: [
    EditSettingSelectBase,
  ],
  components: {
    EditPartsContainerStyle,
    SelectBox,
    Slider,
  },
  data () {
    return {
      options: [],
    }
  },
  methods: {
    // カラム数の更新
    updateNumberOfColumns (value) {
      value < this.partsCount && this.$emit('adjustCurrentTableId', 'DECREASE_COLUMN')
      this.$store.commit('updatePartsColumnCount', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        value,
      })
    },
    updateSpacerSize (value) {
      if (value === '0px') {
        this.$emit('adjustCurrentTableId', 'DELETE_SPACER')
        this.$store.commit('deleteSpacerParts', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
        })
      } else {
        this.spacerWidth === '0px' && this.$emit('adjustCurrentTableId', 'ADD_SPACER')
        this.$store.commit('updateSpacerSize', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          value,
        })
      }
    },
    updatePartsContainer (values) {
      this.$store.commit('updatePartsContainer', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        values,
      })
    },
    updatePartsContainerStyles (styles) {
      this.$store.commit('updatePartsContainerStyles', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        styles,
      })
    }
  },
  computed: {
    partsCount () {
      return this.$store.getters.getPartsCountOfPartsContainer(this.sectionId, this.partsContainerId)
    },
    showSpacerWidth () {
      return this.columnCount > 1
    },
    spacerWidth () {
      if (!this.spacerParts) return null
      // スペーサーがない場合、スペーサーの大きさは0pxとする
      return this.spacerParts.length === 0 ? '0px' : this.spacerParts[0].attrs['width']
    },
    // 最初の要素に適用されるスタイルを解除するため、1番目のリストを非表示にしておく
    hideStyle () {
      return { display: 'none' }
    },
  },
  beforeMount () {
    this.options = this.columnOptions
  },
}
</script>

<style lang="scss">
.column-layout {
  padding-top: 10px;
}
</style>
